import React, { useState } from 'react';
import styled from 'styled-components';

import { Collapse } from 'react-bootstrap';
import Txt from '../atoms/Txt';
import ImgFit from '../atoms/ImgFit';
import Col from '../atoms/FlexColumn';
import useUserPhoto from '../../hooks/useUserPhoto';

const PlanoStatus = styled.div`
  background: #77dd77;
  border-radius: 6px;
  width: 30%;
  text-align: center;
  text-transform: uppercase;
  font-weight: bold;
`;
const TypePlan = styled.div`
  background: #3065ac;
  color: white;
  border-radius: 6px;
  width: 30%;
  text-align: center;
  text-transform: uppercase;
  font-weight: bold;
`;

const Body = styled.div`
  display: flex;
  border: 1px solid #7e7d7a;
  border-radius: 15px;
  margin-top: 1%;
  padding: 1%;
  width: 100%;
  justify-content: space-between;

  @media (max-width: 768px) {
    display: none;
  }

  ul {
    list-style: none;
  }

  i {
    margin: 8px 8px;
    font-size: 40px;

    @media (max-width: 768px) {
      font-size: 23px;
      margin: 1px 6px;
    }
  }

  a:hover {
    text-decoration: none;
  }

  #input[type='file'] {
    display: none;
  }
`;

const PhotoWrapper = styled.div`
  border-radius: 50%;
  border: 1px solid black;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 80px;
  height: 80px;
  margin: 4px 0 8px 0;

  img {
    width: 80px;
    height: 80px;
    border-radius: 50%;
    @media (max-width: 768px) {
      width: 120px;
      height: 120px;
    }
  }
`;

const StyledContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  width: 100%;
`;

const StyledDiv = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: ${({ content }) => content};
  width: ${({ width }) => width || '100%'};
  font-weight: ${({ weight }) => (weight ? 'bold' : '')};

  div {
    margin-right: 8px;
  }
`;

const StyledText = styled.div`
  display: flex;
  justify-content: ${({ direction }) => (direction ? 'center' : 'flex-start')};
  align-items: center;
  width: 100%;
  font-weight: ${({ bold }) => (bold ? 'normal' : 'bold')};
  div {
    margin-right: 10px;
  }
`;

function ProfileCardMenu({ user: userData }) {
  const { avatarURL: img } = useUserPhoto(userData.id, userData.photo);
  const [open, setOpen] = useState(false);

  return (
    <>
      <Body
        type="button"
        aria-controls="example-collapse-text"
        aria-expanded={open}
        onClick={() => setOpen(!open)}>
        <StyledContainer>
          <StyledDiv>
            <StyledDiv width="45%" weight>
              <div>ID:</div>
              <Txt>{userData?.id}</Txt>
            </StyledDiv>

            <StyledDiv>
              <Txt bold transform size={22}>
                {userData?.name}
              </Txt>
            </StyledDiv>

            <StyledDiv content="space-around">
              <TypePlan>{userData?.plan}</TypePlan>
              <PlanoStatus>ATIVO</PlanoStatus>
            </StyledDiv>
          </StyledDiv>

          <Collapse in={open}>
            <StyledContainer id="example-collapse-text">
              <Col>
                <Col>
                  <Txt bold size={22}>
                    {userData?.name}
                  </Txt>
                </Col>
                <PhotoWrapper>
                  <ImgFit id="signup_photo_img" src={img} />
                </PhotoWrapper>

                <Txt bold size={12}>
                  KAKARECANDO DESDE{' '}
                  {userData ? new Date(userData.joinDate).toLocaleDateString('pt-br') : null}
                </Txt>

                <StyledText direction>
                  <Txt href="/usuario/vitrine" color="blue" opacity>
                    Produtos
                  </Txt>
                  <Txt href="/usuario/vendas/concluidas" color="red" opacity>
                    Vendas
                  </Txt>
                </StyledText>

                <StyledText>
                  <div>Tipo de Plano: </div>
                  <Txt>{userData?.plan}</Txt>
                </StyledText>

                <StyledText>
                  <div>Endereço: </div>
                  <Txt>
                    {userData.addresses[0].address}, {userData.addresses[0].number}
                  </Txt>
                </StyledText>

                <StyledText>
                  <div> Telefone:</div>
                  <Txt>{userData?.phone}</Txt>
                </StyledText>
              </Col>
            </StyledContainer>
          </Collapse>
        </StyledContainer>
      </Body>
    </>
  );
}

export default ProfileCardMenu;
